export default {
  page: {
    title: "Support",
    subtitle: "We put communication with our customers first",
    tabs: [
      { key: "notices", label: "Notices" },
      { key: "data", label: "Downloads" },
      { key: "quotation", label: "Quotation" },
    ],
    searchPlaceholder: "Enter search keyword",
    tableNo: "No.",
    tableTitle: "Title",
    tableDate: "Date",
    tableCategory: "Type",
    important: "Important",
    view: "View",
    collapse: "Collapse",
    empty: "No search results found.",
    download: "Download",
    loading: "Loading...",
    fetchError: "Failed to load data. Please try again later.",
    retry: "Try Again",
    requiredInfo: "Information Required for Quotation",
    process: "Quotation Process",
    quoteInquiry: "Request a Quote",
  },
};